import BaseHeadline from "../../../components/general/BaseHeadline"
import { TFunctionCard, THeading } from "../../../types/index"
import FunctionCard from "./FunctionCard"
import { Carousel } from "antd"

type FunctionalityType = {
    heading: THeading
    subheading: THeading
    subheading2: THeading
    functionCard: TFunctionCard[]
}

export default function Functionality(props: FunctionalityType) {
    return (
        <section className="w-full py-20">
            <div className="flex flex-col justify-center">
                <div className="px-8">
                    <BaseHeadline label={props.heading.label} headline={props.heading.headline} text={props.heading.text} center />
                </div>
                <div className="flex md:flex-row justify-center py-15 md:py-20 w-full">
                    <Carousel className="w-full max-w-sm md:max-w-[85rem] p-14" arrows infinite autoplay autoplaySpeed={7000} speed={1500} draggable>
                        {props.functionCard
                            .reduce((chunks: TFunctionCard[][], card, index) => {
                                const chunkIndex = Math.floor(index / 3)
                                if (!chunks[chunkIndex]) {
                                    chunks[chunkIndex] = []
                                }
                                chunks[chunkIndex].push(card)
                                return chunks
                            }, [])
                            .map((chunk, chunkIndex) => (
                                <div key={chunkIndex} className="!flex flex-col md:flex-row justify-center gap-10">
                                    {chunk.map((card, cardIndex) => (
                                        <FunctionCard
                                            key={cardIndex}
                                            headline={card.title}
                                            iconName={card.icon}
                                            theme={card.primary ? "primary" : "secondary"}
                                        />
                                    ))}
                                </div>
                            ))}
                    </Carousel>
                </div>
            </div>
            <div className="flex flex-col py-10 md:py-0 max-w-[85rem] mx-auto">
                <BaseHeadline headline={props.subheading.headline} headlineClassProps="text-primary" tag="h4" center />
                <BaseHeadline headline={props.subheading2.headline} tag="h4" center />
            </div>
        </section>
    )
}
